import orderBy from 'lodash/orderBy';

// src/helpers/factories/menu/cardFactories/itemGroups/itemGroupsAssignedItemsFactory.ts
var itemGroupsAssignedItemsFactoryCore = (items, itemGroupAssignedItems, handleDeleteItem) => orderBy(Object.values(itemGroupAssignedItems), "sortPriority").map((itemOfItemGroup) => {
  const id = itemOfItemGroup.itemId;
  const item = items[id];
  if (item) {
    return {
      id: item.itemId,
      title: item.name,
      onDelete: handleDeleteItem,
      onPress: () => console.info(id),
      additionalPrice: itemOfItemGroup.additionalPrice,
      active: itemOfItemGroup.active,
      isDisabled: itemOfItemGroup.isDisabled || false,
      sortPriority: itemOfItemGroup.sortPriority
    };
  } else
    return null;
}).filter((value) => value !== null);

export { itemGroupsAssignedItemsFactoryCore };
